import { Routes } from '@angular/router';
import { AuthGuard } from '../../_helper/auth.guard';
import { Role } from '../../_models/role';
const userRole = localStorage.getItem('userRole')

export const content: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
    data: {
    }
  },
    {
    path: 'media',
    loadChildren: () => import('../../components/media/media.module').then(m => m.MediaModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Media",
    }
  },
  {
    path: 'users',
    loadChildren: () => import('../../components/users/users.module').then(m => m.UsersModule),
    data: {
      breadcrumb: "Users",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('../../components/setting/setting.module').then(m => m.SettingModule),
    data: {
      breadcrumb: "Settings"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stream',
    loadChildren: () => import('../../components/stream/stream.module').then(m => m.StreamModule),
    data: {
      breadcrumb: "Stream"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'branch',
    loadChildren: () => import('../../components/branch/branch.module').then(m => m.BranchModule),
    data: {
      breadcrumb: "Branch",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'degree',
    loadChildren: () => import('../../components/degree/degree.module').then(m => m.DegreeModule),
    data: {
      breadcrumb: "Degree"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'permissions',
    loadChildren: () => import('../../components/permissions/permissions.module').then(m => m.PermissionsModule),
    data: {
      breadcrumb: "Permissions"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'specialization',
    loadChildren: () => import('../../components/specialization/specialization.module').then(m => m.SpecializationModule),
    data: {
      breadcrumb: "Specialization"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'course',
    loadChildren: () => import('../../components/course/course.module').then(m => m.CourseModule),
    data: {
      breadcrumb: "Course"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'country',
    loadChildren: () => import('../../components/country/country.module').then(m => m.CountryModule),
    data: {
      breadcrumb: "Country"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'university',
    loadChildren: () => import('../../components/university/university.module').then(m => m.UniversityModule),
    data: {
      breadcrumb: "University"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'rounds',
    loadChildren: () => import('../../components/rounds/rounds.module').then(m => m.RoundsModule),
    data: {
      breadcrumb: "Rounds"
    },
    canActivate: [AuthGuard],
  },
  
  {
    path: 'programtype',
    loadChildren: () => import('../../components/programtype/programtype.module').then(m => m.ProgramtypeModule),
    data: {
      breadcrumb: "Programtype"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'typeofcollege',
    loadChildren: () => import('../../components/typeofcollege/typeofcollege.module').then(m => m.TypeofcollegeModule),
    data: {
      breadcrumb: "Typeofcollege"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'genderaccepted',
    loadChildren: () => import('../../components/genderaccepted/genderaccepted.module').then(m => m.GenderacceptedModule),
    data: {
      breadcrumb: "Gender Accepted"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'courseduration',
    loadChildren: () => import('../../components/courseduration/courseduration.module').then(m => m.CoursedurationModule),
    data: {
      breadcrumb: "Courseduration"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'castecategory',
    loadChildren: () => import('../../components/castecategory/castecategory.module').then(m => m.CastecategoryModule),
    data: {
      breadcrumb: "Caste Category"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'modules',
    loadChildren: () => import('../../components/modules/modules.module').then(m => m.ModulesModule),
    data: {
      breadcrumb: "Modules"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'facilities',
    loadChildren: () => import('../../components/facilities/facilities.module').then(m => m.FacilitiesModule),
    data: {
      breadcrumb: "Facilities"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'rankings',
    loadChildren: () => import('../../components/rankings/rankings.module').then(m => m.RankingsModule),
    data: {
      breadcrumb: "Rankings"
    },
    canActivate: [AuthGuard],
  },
   {
    path: 'onlineexam',
    loadChildren: () => import('../../components/onlineexam/onlineexam.module').then(m => m.OnlineexamModule),
    data: {
      breadcrumb: "Onlineexam"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'state',
    loadChildren: () => import('../../components/state/state.module').then(m => m.StateModule),
    data: {
      breadcrumb: "State"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'city',
    loadChildren: () => import('../../components/city/city.module').then(m => m.CityModule),
    data: {
      breadcrumb: "City"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-by',
    loadChildren: () => import('../../components/approved-by/approved-by.module').then(m => m.ApprovedByModule),
    data: {
      breadcrumb: "Approved By"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'keywords',
    loadChildren: () => import('../../components/keywords/keywords.module').then(m => m.KeywordsModule),
    data: {
      breadcrumb: "Keywords"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'ownership',
    loadChildren: () => import('../../components/ownership/ownership.module').then(m => m.OwnershipModule),
    data: {
      breadcrumb: "Ownership"
    },
    canActivate: [AuthGuard],
  },
   {
    path: 'intakesession',
    loadChildren: () => import('../../components/intakesession/intakesession.module').then(m => m.IntakeSessionModule),
    data: {
      breadcrumb: "Intake Sessions"
    },
    canActivate: [AuthGuard],
  },
   {
    path: 'deliverymode',
    loadChildren: () => import('../../components/deliverymode/deliverymode.module').then(m => m.DeliveryModeModule),
    data: {
      breadcrumb: "Delivery Mode"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'tags',
    loadChildren: () => import('../../components/tags/tags.module').then(m => m.TagsModule),
    data: {
      breadcrumb: "Tags"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'accreditions',
    loadChildren: () => import('../../components/accreditions/accreditions.module').then(m => m.AccreditionsModule),
    data: {
      breadcrumb: "Accreditions"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'amenities',
    loadChildren: () => import('../../components/amenities/amenities.module').then(m => m.AmenitiesModule),
    data: {
      breadcrumb: "Amenities"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'listings',
    loadChildren: () => import('../../components/listings/listings.module').then(m => m.ListingsModule),
    data: {
      breadcrumb: "Listings"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'college-details',
    loadChildren: () => import('../../components/college-details/college-details.module').then(m => m.CollegeDetailsModule),
    data: {
      breadcrumb: "College Details"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'student-details',
    loadChildren: () => import('../../components/student-details/student-details.module').then(m => m.StudentDetailsModule),
    data: {
      breadcrumb: "Student Details"
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'collegeinfo',
    loadChildren: () => import('../../components/products/products.module').then(m => m.ProductsModule),
    data: {
      breadcrumb: "Collegeinfo",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'sales',
    loadChildren: () => import('../../components/sales/sales.module').then(m => m.SalesModule),
    data: {
      breadcrumb: "Sales",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'coupons',
    loadChildren: () => import('../../components/coupons/coupons.module').then(m => m.CouponsModule),
    data: {
      breadcrumb: "Coupons"
    },
    canActivate: [AuthGuard],
  }, 
  
  {
    path: 'media',
    loadChildren: () => import('../../components/media/media.module').then(m => m.MediaModule),
    data: {
      breadcrumb: "Media",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'menus',
    loadChildren: () => import('../../components/menus/menus.module').then(m => m.MenusModule),
    data: {
      breadcrumb: "Menus"
    },
    canActivate: [AuthGuard],
  },
  
  {
    path: 'vendors',
    loadChildren: () => import('../../components/vendors/vendors.module').then(m => m.VendorsModule),
    data: {
      breadcrumb: "College"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'localization',
    loadChildren: () => import('../../components/localization/localization.module').then(m => m.LocalizationModule),
    data: {
      breadcrumb: "Localization"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('../../components/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice',
    loadChildren: () => import('../../components/invoice/invoice.module').then(m => m.InvoiceModule),
    data: {
      breadcrumb: "Invoice"
    },
    canActivate: [AuthGuard],
  }, */
];